// @ts-ignore
 
import request from "src/lib/axios";

/** 城市列表 GET /api/v1/hq/cities */
export async function CityControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.CityControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputCityDtoArray>("/api/v1/hq/cities", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 开通 / 更新城市 POST /api/v1/hq/cities */
export async function CityControllerUpsertV1(
  body: MyApi.UpsertCityDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputCityDto>("/api/v1/hq/cities", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 某城市的活跃渠道商列表 GET /api/v1/hq/cities/${param0}/coverage */
export async function CityControllerTenantsInCityV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.CityControllerTenantsInCityV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantCityCoverageDtoArray>(
    `/api/v1/hq/cities/${param0}/coverage`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 渠道商加入城市覆盖 POST /api/v1/hq/cities/${param0}/coverage */
export async function CityControllerCoverV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.CityControllerCoverV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantCityCoverageDto>(
    `/api/v1/hq/cities/${param0}/coverage`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 城市下辖区县列表 GET /api/v1/hq/cities/${param0}/districts */
export async function CityControllerDistrictsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.CityControllerDistrictsV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCityDistrictDtoArray>(
    `/api/v1/hq/cities/${param0}/districts`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 某渠道商的覆盖城市列表 GET /api/v1/hq/cities/coverage/by-tenant/${param0} */
export async function CityControllerCoverageByTenantV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.CityControllerCoverageByTenantV1Params,
  options?: { [key: string]: any }
) {
  const { tenantId: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantCityCoverageDtoArray>(
    `/api/v1/hq/cities/coverage/by-tenant/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
